import _ from 'underscore'
import deepmerge from 'deepmerge'
import constants from '@/constants'
import Vue from 'vue'

export default {

	difference: function(obj1, obj2) {

		// If both inputs aren't objects or are null, return undefined
		if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || 
			obj1 === null || obj2 === null) {
			return undefined;
		}

		const result = {};

		// Get all unique keys from both objects
		const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

		for (const key of allKeys) {
			const val1 = obj1[key];
			const val2 = obj2[key];

			// If one value exists and the other doesn't
			if (val1 === undefined && val2 !== undefined) {
				result[key] = val2;
			} else if (val2 === undefined && val1 !== undefined) {
				result[key] = val1;
			}
			// If both are objects, recursively compare
			else if (typeof val1 === 'object' && typeof val2 === 'object' &&
					val1 !== null && val2 !== null) {
				const nestedDiff = this.difference(val1, val2);
				if (Object.keys(nestedDiff).length > 0) {
					result[key] = nestedDiff;
				}
			}
			// If values are different primitives
			else if (val1 !== val2) {
				result[key] = val2;
			}
		}

		return result;

	},

	rangeOverlap: function(startA, endA, startB, endB) {
	
		if(startA <= startB && endA > startB) {
		
			return true
		
		} else if(startA < endB && endA > endB) {
		
			return true
		
		} else if(startA > startB && endA < endB) {
		
			return true
		
		} else {
		
			return false
		
		}

	},

	count: function(value) {

		return _.keys(value).length

	},

	options: function(values, field, keyField) {

		field = field || 'name'
		keyField = keyField || 'id'

		var options = []

		_.each(values, function(value, key) {

			options.push({
				value: (keyField && _.isObject(value)) ? value[keyField] : key,
				text: (field && _.isObject(value)) ? value[field] : value
			})

		})

		return options

	},

	in: function(value, array, keys) {

		keys = keys || false

		if(keys) {

			return _.contains(_.filter(array, function(value, key) {

				return _.contains(keys, key)

			}), value)

		} else {

			return _.contains(array, value)

		}

	},

	generateKey: function() {

		var length = 8
		var result = ''
		var characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
		var charactersLength = characters.length

		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength))
		}

		return result

	},

    copy: function(value) {

        return JSON.parse(JSON.stringify(value))
        
    },

	array: {

		string: function(dest) {

			for(var i=0; i<dest.length; i++) {

				dest[i] = dest[i].toString()

			}

			return dest

		},

		int: function(dest) {

			for(var i=0; i<dest.length; i++) {

				dest[i] = parseInt(dest[i])

			}

			return dest

		},

		add: function(dest, value) {

			if (!_.contains(dest, value)) dest.push(value)

		},

		remove: function(dest, value) {

			if (_.contains(dest, value)) {

				dest.splice(dest.indexOf(value), 1)

			}

		},

		toggle: function(dest, value) {

			if (_.contains(dest, value)) {

				this.remove(dest, value)

			} else {

				this.add(dest, value)

			}

		}

	},

	structure: {

		copy: function(value) {
	
			return JSON.parse(JSON.stringify(value))
			
		},

		poke: function(data, name, value, type) {
	
			var parts = name.split('.')
	
			if (parts.length > 1) {
	
				this.poke(data[parts[0]], parts.slice(1).join('.'), value, type)
	
			} else {
	
				if (type === constants.store.commit.update) {
					
					data[name] = value
	
				} else if (type === constants.store.commit.add) {
	
					if (!_.contains(data[name], value)) {
	
						data[name].push(value)
	
					}
	
				} else if (type === constants.store.commit.remove) {
	
					if (_.contains(data[name], value)) {
	
						data[name].splice(data[name].indexOf(value), 1)
	
					}
	
				}
	
			}
	
		},

		merge: function(value, full) {

			value = this.copy(value)
			full = this.copy(full)

			return deepmerge(full, value)

		},

		flatten: function(data, path, flat) {

			flat = flat || {}
			path = path || ''
	
			_.each(data, function(value, key) {
	
				if (_.isObject(value) && !_.isArray(value)) {
	
					flat = this.flatten(value, path + key + '.', flat)
	
				} else {
	
					flat[path + key] = value
	
				}
	
			}.bind(this))
	
			return flat
	
		}

	},

	collection: {
	
		$find: function(collection, value) {

			var id = (typeof value === 'object') ? value.id : value

			var index = _.findIndex(collection, {
				id: id
			})

			return (index === -1) ? false : index

		},

		get: function(collection, value) {

			return collection[this.$find(collection, value)]

		},

		add: function(collection, value) {

			if (!this.$find(collection, value)) collection.push(value)

		},

		remove: function(collection, value) {

			var index = this.$find(collection, value)

			if (index !== false) collection.splice(index, 1)

			return index

		},

		update: function(collection, data) {

			var index = this.$find(collection, data)

			if (index !== false) Vue.set(collection, index, data)

			return index

		}

	}

}